import type { SVGProps } from "react";
export interface ArcheryBowIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ArcheryBowIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ArcheryBowIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.216 1.193a1.13 1.13 0 0 1 1.287-.2l1.466.733c.77.385 1.648.503 2.493.334l2.209-.44a6.125 6.125 0 0 1 6.579 3.07l1.078 1.978 1.98 1.083a6.12 6.12 0 0 1 3.151 6.085l-.078.492-.442 2.21a3.88 3.88 0 0 0 .334 2.494l.734 1.465a1.125 1.125 0 0 1-1.478 1.524l-9.135-4.215a1.126 1.126 0 1 1 .944-2.044l6.452 2.978a6.1 6.1 0 0 1-.057-2.642l.442-2.21.05-.313a3.88 3.88 0 0 0-1.723-3.687l-.27-.162-2.271-1.238a1.13 1.13 0 0 1-.448-.45L14.275 5.77a3.88 3.88 0 0 0-4.163-1.944l-2.21.441a6.1 6.1 0 0 1-2.645-.057l2.98 6.454.044.107a1.125 1.125 0 0 1-2.033.938l-.053-.102-4.216-9.134c-.2-.434-.105-.947.237-1.28"
      />
      <path
        fill={color}
        d="M4.716 17.875H5c.621 0 1.125.503 1.125 1.125v.284l.75-.75v-1.41h-1.41l-.75.75ZM23.125 5.5a1.125 1.125 0 0 1-2.25 0v-.784l-11.75 11.75V19c0 .298-.119.584-.33.795l-3 3a1.125 1.125 0 0 1-1.92-.796v-1.874H2a1.126 1.126 0 0 1-.795-1.92l3-3 .171-.142c.183-.122.4-.189.624-.189h2.534l11.75-11.749H18.5a1.125 1.125 0 0 1 0-2.25H22c.62 0 1.125.504 1.125 1.125z"
      />
    </svg>
  );
}
